import { CommonModule } from "@angular/common";
import { Component, forwardRef, inject, input, OnInit } from "@angular/core";
import {
  ControlContainer,
  ControlValueAccessor,
  FormGroup,
  FormGroupDirective,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
  ReactiveFormsModule,
} from "@angular/forms";
import { MaterialModule } from "src/app/core/material/material.module";
import { OnlyNumberDirective } from "src/app/shared/directives/only-number.directive";
import { LabelInputComponent } from "../../label-input/label-input.component";

@Component({
  selector: "app-input-only-numbers",
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    OnlyNumberDirective,
    LabelInputComponent,
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputOnlyNumbersComponent),
    },
  ],
  templateUrl: "./input-only-numbers.component.html",
})
export class InputOnlyNumbersComponent implements OnInit, ControlValueAccessor {
  // Variables
  form: FormGroup = new FormGroup({});

  // Services
  private parent = inject(FormGroupDirective);
  ngControl = inject(NgControl, { optional: true, self: true })!;

  // Inputs
  readonly nameControl = input<string>();
  readonly textLabel = input<string>();
  readonly required = input<boolean>(false);
  readonly maxlength = input<any>("255");
  readonly value = input<any>();
  readonly textTooltip = input<string>();
  readonly hasTooltip = input<boolean>(false);
  readonly placeholder = input<string>("");
  readonly disabled = input<boolean>(false);
  readonly textRequired = input<string>("");
  readonly isTextCenter = input<boolean>(false);

  get f() {
    return this.form.controls;
  }

  constructor() {
    if (this.ngControl != null) this.ngControl.valueAccessor = this;
  }

  writeValue(value: any): void {
    if (this.f[this.nameControl()!]) {
      this.f[this.nameControl()!].setValue(value);
    }
  }

  onChange: (_: any) => void = (value: any) => {
    if (this.f[this.nameControl()!]) {
      this.f[this.nameControl()!].setValue(value);
    }
  };

  onTouched: () => void = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit() {
    this.form = this.parent.form;
  }
}
